import React, { useState, } from "react";
import { utils } from "../../utils/Utils";
import detect from "../../../node_modules/detect.js/detect";
import getJPEGFileFromHEICWeb from "../../utils/Webhook-jpg";
import ReactDom from "react-dom";
import Form from "react-bootstrap/Form";
import $ from "jquery";
import SimpleImageEditor from "../SimpleImageEditor";
import store from "app/store";
import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";

const FileUpload = (props) => {
  const [enablePhotoEditor, setEnablePhotoEditor] = useState(true);
  const { IsOpenEditor } = store.getState().Business;

  const savecdn = props.savecdn;
  const setLoading =props.setLoading;

  const CheckFileSize = (ContentLength, MaxLength) => {
    if (ContentLength <= MaxLength) {
      return true;
    }
    return false;
  };

  function isValidFile(validExtensions, fileName) {
    fileName = fileName.toLowerCase();
    var validHEICExtensions = /(HEIC|heic)$/i;
    if (fileName.match(validExtensions) != null) {
      return true;
    } else if (
      fileName.match(validHEICExtensions) != null &&
      isWebBrowserSupportHEIC()
    ) {
      return true;
    }

    return false;
  }
  function isWebBrowserSupportHEIC() {
    var b = detect.parse(navigator.userAgent);
    var browserName = b.browser.family.toLowerCase(),
      browserversion = parseInt(b.browser.version);
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    if (isIE || isEdge) {
      return false;
    } else if (
      (browserName.indexOf("chrome") > -1 && browserversion > 67) ||
      (browserName.indexOf("firefox") > -1 && browserversion > 61) ||
      (browserName.indexOf("safari") > -1 && browserversion > 11.1)
    )
      return true;
    return false;
  }

  const GeneralUploadFileClick = (e) => {
    e.target.value = "";
  };

  const GeneralFileUploadValidation = (filesDetails, divMain) => {

    setLoading(true);
    var isLowQualityPreview;
    if (isValidFile(/(ico|gif|png|jpg|jpeg|ICO|GIF|PNG|JPG|JPEG)$/i, filesDetails.name)) {
      var MaxLength = 5242880;
      if (CheckFileSize(filesDetails.size, MaxLength)) {
        if (
          filesDetails.size !== "undefined" &&
          filesDetails.size < 5242880
        ) {
          isLowQualityPreview = false;
        } else {
          isLowQualityPreview = true;
        }
        if (enablePhotoEditor === true && IsOpenEditor === true) {
          return ReactDom.render(
            <SimpleImageEditor src={URL.createObjectURL(filesDetails)} onSave={(dataUrl,base64,height,width,fd)=>{
              savecdn(filesDetails.name, base64, height, width, fd);
            }} onClose={()=>{
              ReactDom.unmountComponentAtNode(document.getElementById("OpenDialog1"));
            }} />,

            document.getElementById("OpenDialog1"),
            setLoading(false)
          );
        } else {
          if (isValidFile(/(gif|GIF)$/i, filesDetails.name)) {
            setLoading(false)
            const BodyEnu = () => {
              return (
                <div>
                  {props.ValidFileExtensionMessage}
                </div>
              );
            };
            const TitleEnum = "Please select valid file.";
            const BodyEnum = BodyEnu();
            utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
            

          } else {
            setLoading(false)
            var reader = new FileReader();
            reader.readAsDataURL(filesDetails);
            reader.onload = function () {
              var base64 = reader.result.split(",");
              savecdn(filesDetails.name, base64[1], divMain, filesDetails);
            };
          }
        }
      } else {
        setLoading(false)
        const TitleEnum = "Invalid Image Size";
        const BodyEnum = "File size limit exceeds 5 MB.";
        utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
      }
    } else {
      setLoading(false)
      const TitleEnum = "Invalid File Type";
      const BodyEnum = props.ValidFileExtensionMessage;
      utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");

      if(props.onInvalid){
        props.onInvalid();
      }

    }
  };

  const onChangeGeneralUploadFile = (e, divMain, props) => {
    setLoading(true);
    e.target.parentNode.parentNode.classList.remove('over');

    var filesDetails = e.target.files[0];
    var filesName;
    var isLowQualityPreview;
    if (isValidFile(/(HEIC|heic)$/i, filesDetails.name)) {
      
      var MaxLength = 5242880;
      if (CheckFileSize(filesDetails.size, MaxLength)) {
        if (filesDetails.size !== "undefined" && filesDetails.size < 5242880) {
          isLowQualityPreview = false;
        } else {
          isLowQualityPreview = true;
        }
        // $("#generalupload").attr("style", "display:block");
        filesName = e.target.files[0].name
          .toLowerCase()
          .replace(/\.heic/, ".jpeg");
        getJPEGFileFromHEICWeb(filesDetails, filesName, function (file) {
          filesDetails = file;
          $("#generalupload").attr("style", "display:none");

          if (enablePhotoEditor === true) {
            return ReactDom.render(

              <SimpleImageEditor
                src={URL.createObjectURL(filesDetails)}
                onSave={(dataUrl,base64,height,width,fd)=>{
                  savecdn(filesDetails.name, base64, height, width, fd);
                }} onClose={()=>{
                  ReactDom.unmountComponentAtNode(document.getElementById("OpenDialog1"));
                }} />,


              document.getElementById("OpenDialog1"),
              setLoading(false)
            );
          } else {
            setLoading(false)
            var reader = new FileReader();
            reader.readAsDataURL(filesDetails);
            reader.onload = function () {
              var base64 = reader.result.split(",");
              savecdn(filesDetails.name, base64[1], filesDetails, divMain);
            };
          }
        },(alert)=>{
          setLoading(false)
          AlertConfirm("There was an error reading this image, please check the filetype and try again.");
        });
      } else {
        setLoading(false)
        const TitleEnum = "Alert!";
        const BodyEnum = "File size limit exceeds 5 MB.";
        utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
      }
    } else {
      GeneralFileUploadValidation(filesDetails, divMain);
    }
  };

  const handleDragEnter =(e)=>{
    
    let getparent = e.target.parentNode.parentNode;
    getparent.classList.add('over')
  }
  const handleDragLeave =(e)=>{
    let getparent = e.target.parentNode.parentNode;
    getparent.classList.remove('over')
  }

  return (
    <div>
      <Form.Control
        type="file"
        className={`uploadfile-control ${props.className ? props.className :""}` }
        id="generalupload"
        onAbort={()=>{console.log("abortede!!!")}}
        onClick={GeneralUploadFileClick}
        onChange={onChangeGeneralUploadFile}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      />
    </div>
  );
};

export default FileUpload;
